var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: ", ";\n  text-align: center;\n  user-select: none;\n"], ["\n  width: ", ";\n  height: ", ";\n  margin: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: ", ";\n  text-align: center;\n  user-select: none;\n"])), function (_a) {
    var component = _a.theme.component;
    return component.pagination.width;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.height;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.fontSize.control;
}, function (_a) {
    var component = _a.theme.component;
    return component.pagination.height;
});
var Break = function () { return React.createElement(Wrapper, null, "\u2026"); };
export default Break;
var templateObject_1;
//# sourceMappingURL=index.js.map